var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusDelivered = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.174959 15.5L17.6666 8L0.174959 0.5L0.166626 6.33333L12.6666 8L0.166626 9.66667L0.174959 15.5Z",
    fill: "#4E9018"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusDelivered);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_status_delivered.8cb76e96511147533c02269eb38f2df9.svg";